import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { TypedTranslateHtml } from '@change-corgi/core-react/i18n';

import { PROOF_ITEMS } from './proofItems';

type Props = Readonly<{
	index: number;
	iconSize: number;
	textSize: 'x-small' | 'small' | 'medium';
}>;

/**
 * One icon + text pair of the cycling social proof.
 *
 * Keyed on `index` so the enter animation replays whenever the cycle advances. The icon is
 * decorative — it carries no accessible name, so the design system renders it `aria-hidden`.
 */
export const ProofItem: React.FC<Props> = ({ index, iconSize, textSize }) => {
	const { key, Icon } = PROOF_ITEMS[index];

	return (
		<span
			key={index}
			data-testid="proof-item"
			className="motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-[6px] motion-safe:duration-t5 motion-safe:ease-inform flex items-center justify-center gap-2 text-center"
		>
			<Icon size={iconSize} />
			<Text as="span" variant="body" size={textSize} fontWeight="normal">
				<TypedTranslateHtml value={key} />
			</Text>
		</span>
	);
};
